import yxhJsBridge from '@/shared/yxhJsBridge';
import type VueRouter from 'vue-router';
import { detectEnv } from '@/shared/detect';

export default function clearAllAppBackGuard(router: VueRouter) {
  /**
   * 切换路由前清除所有拦截app后退的jsbridge
   */
  router.beforeEach((to, from, next) => {
    if (detectEnv.yxh) {
      yxhJsBridge.unwatchAllAppBack();
    }

    next();
  });
}
